import React from 'react';
import * as Form from 'components/form';
import { useForm } from 'components/form';
import * as Page from 'components/page';
import { RHP } from 'providers';

export function StartupStep10({ useRankingStartup, t }) {
    const { vars, putStartupRankingApplication } = useRankingStartup;
    const { application } = vars;
    const { steps } = application;

    const ack = application?.rulesAcknowledgement || {};

    const form = useForm({
        realRelationships: !!ack.realRelationships,
        validatedByOtherParty: !!ack.validatedByOtherParty,
        officialPublicationRequiresAudit: !!ack.officialPublicationRequiresAudit,
        auditCost: !!ack.auditCost,
        caseRequirement: !!ack.caseRequirement,
        awardsOptional: !!ack.awardsOptional
    });

    // Step 10 (Termo de Ciência) is always accessible - not blocked by step 9
    if (!steps || steps.step8 !== true) {
        RHP.replace('/ranking/latam/startup/');
        return null;
    }

    const fields = {
        realRelationships: {
            error: form.errors.realRelationships,
            label: t('StartupStep10.ack1'),
            name: 'realRelationships',
            type: 'checkbox',
            required: true,
            value: form.values.realRelationships,
            onChange: form.handleChange
        },
        validatedByOtherParty: {
            error: form.errors.validatedByOtherParty,
            label: t('StartupStep10.ack2'),
            name: 'validatedByOtherParty',
            type: 'checkbox',
            required: true,
            value: form.values.validatedByOtherParty,
            onChange: form.handleChange
        },
        officialPublicationRequiresAudit: {
            error: form.errors.officialPublicationRequiresAudit,
            label: t('StartupStep10.ack3'),
            name: 'officialPublicationRequiresAudit',
            type: 'checkbox',
            required: true,
            value: form.values.officialPublicationRequiresAudit,
            onChange: form.handleChange
        },
        auditCost: {
            error: form.errors.auditCost,
            label: t('StartupStep10.ack4'),
            name: 'auditCost',
            type: 'checkbox',
            required: true,
            value: form.values.auditCost,
            onChange: form.handleChange
        },
        caseRequirement: {
            error: form.errors.caseRequirement,
            label: t('StartupStep10.ack5'),
            name: 'caseRequirement',
            type: 'checkbox',
            required: true,
            value: form.values.caseRequirement,
            onChange: form.handleChange
        },
        awardsOptional: {
            error: form.errors.awardsOptional,
            label: t('StartupStep10.ack6'),
            name: 'awardsOptional',
            type: 'checkbox',
            required: true,
            value: form.values.awardsOptional,
            onChange: form.handleChange
        }
    };

    const onSubmit = async values => {
        const payload = {
            ...application,
            rulesAcknowledgement: {
                realRelationships: !!values.realRelationships,
                validatedByOtherParty: !!values.validatedByOtherParty,
                officialPublicationRequiresAudit: !!values.officialPublicationRequiresAudit,
                auditCost: !!values.auditCost,
                caseRequirement: !!values.caseRequirement,
                awardsOptional: !!values.awardsOptional
            }
        };

        if (!payload.steps) payload.steps = {};
        payload.steps.step10 = true;

        return putStartupRankingApplication(payload)
            .then(() => RHP.push('/ranking/latam/startup/step11'))
            .catch(() => form.submited());
    };

    const evSubmit = ev => form.handleSubmit(ev, onSubmit);

    return (
        <Page.Page name="StartupStep10" back="/ranking/latam/startup" customBackText={t('glossary:backToRanking')}>
            <Page.Title>{t('StartupStep10.title')}</Page.Title>
            <Page.Descr>{t('StartupStep10.description')}</Page.Descr>

            <Form.Form name="StartupStep10Form" onSubmit={evSubmit}>
                <Form.Field {...fields.realRelationships} />
                <Form.Field {...fields.validatedByOtherParty} />
                <Form.Field {...fields.officialPublicationRequiresAudit} />
                <Form.Field {...fields.auditCost} />
                <Form.Field {...fields.caseRequirement} />
                <Form.Field {...fields.awardsOptional} />

                <div style={{ display: 'flex', gap: 10, marginTop: 10 }}>
                    <Page.Buttn style={{ width: '25%' }} to="/ranking/latam/startup/step9">
                        <span className="icon far fa-long-arrow-left" aria-hidden="true" />
                        <span className="text" style={{ margin: '0 0 0 auto' }}>
                            {t('glossary:back')}
                        </span>
                    </Page.Buttn>

                    <div style={{ width: '75%' }}>
                        <Form.Submt text={t('glossary:save')}>
                            <span className="icon far fa-long-arrow-right" aria-hidden="true" />
                        </Form.Submt>
                    </div>
                </div>
            </Form.Form>
        </Page.Page>
    );
}
